'use client';
import React, { useState, useEffect } from "react";
import Modal from "react-modal";

import axios from "axios";
import dynamic from "next/dynamic";
import { BACKEND_URL } from "../../utils/constants";
import { usePathname } from "next/navigation";
const PhoneInput = dynamic(() => import("react-phone-input-2"), { ssr: true });



const ModalForm = ({ isOpen, setISOpen }) => {
  const path = usePathname();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState('');
  const [errorEmail, setErrorEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberEmpty, setPhoneNumberEmpty] = useState("");
  const [pathName,setPathname] = useState('Home');

  
  useEffect(() => {
    
    
    const rootElement = document.getElementById("__next");
    if (rootElement) {
      Modal.setAppElement(rootElement);
    }
  }, []);

  useEffect(() => {
    
    
    if (path === '/') {
      setPathname('Home');
    } else {
      const data = path.split('/')[1];
      setPathname(data);
    }
  }, [path]); 

  const ismbbs = path.startsWith("/study-mbbs-abroad")
  const handleSubmit = async () => {

    if (phoneNumberEmpty == '') {
      setError('Phone number is required');
      return;
    }
    if (email == '') {
      setErrorEmail('Email is required');
      return;
    }
    setError('');
    setErrorEmail('');
    try {

      const response = await axios.post(`${BACKEND_URL}/lsq/create-lead`, {
        EmailAddress: email,
        Phone: phone,
        interestedProgram:`Educafic_${pathName}_Apply_Now`,
      });

      if (response.status === 200 || response.status === 201) {
        localStorage.setItem("formFilled", "true");
        localStorage.setItem("email", email);
        localStorage.setItem("phone", phone);
        setEmail("");
        setPhone("");
        setPhoneNumber("");
        onClose();
      } else {
        throw new Error("Failed to submit the form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handlePhoneChange = (value: string, countryObj) => {
    if (value) {
      const dialCode = countryObj.dialCode;
      const phoneValue = value.replace(/\D/g, "");
      const phoneNo = phoneValue.replace(new RegExp(`^${dialCode}`), '');
      // Format phone number after removing non-digit characters
      const formattedPhone = `+${dialCode}-${phoneNo}`;
      setPhone(formattedPhone);
      setPhoneNumber(phoneValue);  // Update internal phone state
      setPhoneNumberEmpty(phoneNo)
    } else {
      setPhone("");
    }
  };

  const onClose = () => {
    setISOpen(!isOpen)
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Study Abroad Scholarships"
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      style={{
        overlay: {
          zIndex: 50, // Make sure the overlay has a lower z-index than the modal content
        },
      }}
    >
      <div
        className="w-full max-w-6xl mx-auto p-6 !z-50  rounded-lg shadow-lg max-md:bg-gray-50 bg-[url('/Home/popupmobile.png')] md:bg-[url('/Home/popup.png')] bg-cover bg-center relative h-[65%] lg:h-[78%]"
        style={{
          width: "90%",
        }}
      >

        <div className="flex items-center justify-center h-full w-full lg:pl-6 ">
          <div className="w-full ">
            <h2 className="md:text-3xl lg:text-4xl text-2xl font-extrabold text-[#3C3C3C] mb-1 font-poppins lg:w-full">
              Study Abroad Scholarships
            </h2>
            <h3 className="md:text-2xl lg:text-3xl text-lg font-poppins font-extrabold !bg-clip-text bg-gradient-to-r from-[#0FB995] to-[#0074FE] text-transparent mb-6">
              Up to 100% Funded!
            </h3>
            <p className="md:text-lg text-md text-black font-outfit md:w-1/2">
              Don’t let finances hold you back!
            </p>
            <p className="md:text-lg text-md text-black font-outfit mb-6 md:w-1/2">
              Get matched with scholarships, grants, and exclusive funding.
            </p>
            <div className="flex flex-col md:flex-row md:w-1/2 w-full md:gap-x-4">
              <div className="flex flex-col mb-4">
                <input
                  type="email"
                  placeholder="Enter your email...."
                  value={email}
                  required
                  onChange={(e) => setEmail(e.target.value)}
                  className=" max-sm:w-[70%] p-4 border border-gray-300 rounded-lg "
                />
                {errorEmail && <span className="text-red-500 mb-2 mt-2">{errorEmail}</span>}
              </div>
              <div className="w-1/2">
                <PhoneInput
                  country={"in"}
                  value={phoneNumber}
                  onChange={handlePhoneChange}
                  containerClass="!w-[190px] xs:!w-[310px] sm:!w-[200px] md:!w-[167px] lg:!w-[212px] !h-[55px]"
                  inputClass="!w-[190px] xs:!w-[310px] sm:!w-[280px] md:!w-[167px] lg:!w-[212px] xl:!w-[256px] p-4 border border-gray-300 rounded-lg !h-[55px]"
                  buttonStyle={{ borderRadius: "8px", borderColor: "#D1D5DB" }} // Adjust border radius
                />
                {error && <span className="text-red-500">{error}</span>}
              </div>
            </div>

            <button
              onClick={handleSubmit}
              className={`w-1/2 py-4 mt-4 md:mt-0 bg-teal-500 text-white max-md:text-sm font-semibold rounded-lg hover:bg-teal-600 ${ismbbs ? "mbbs-start-btn" : "start-btn"}`}
            >
              Get Started now
            </button>
          </div>
        </div>
        <div className="absolute top-3 right-3 text-xl text-gray-600">
          {/* Show countdown before the close button */}
          <button onClick={onClose} className="hover:text-gray-800 p-3">
            X
          </button>
          {/* {showCloseButton ? (
          <button onClick={onClose} className="hover:text-gray-800 p-3">
            X
          </button>
        ) : (
          <span className="text-sm border rounded-full p-3">{countdown}s</span> // Show countdown
        )} */}
        </div>
      </div>

    </Modal >
  );
};

export default ModalForm;
